import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { Params } from '../../../state/reducers/types'
import { TableName } from '../../../tables'
import { toList } from '../../../utils/listUtils'
import { useLoaders, ListResponse } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Customer } from '../state/types'

export const useCustomerLoaders = () => {
    const systemHooks = useSystemStateHooks()

    const loaders = useLoaders()
    
    return (companyId = systemHooks.companyId) => {
        const loadAllCustomers = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.CUSTOMERS, options)
            return response.dataTypes as Customer[]
        }
        
        const loadCustomersBatch = (
            startKey?: Params,
            limit = 10,
        ): Promise<ListResponse<Customer>> => {
            const { loadBatch } = loaders(companyId)
            return loadBatch(TableName.CUSTOMERS, startKey, limit) as Promise<ListResponse<Customer>>
        }

        const loadCustomer = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.CUSTOMERS, id, dbRequest) as Promise<O<Customer>>
        }

        const loadCustomers = (
            ids: string[],
            dbRequest = false
        ) => {
            const { loadByIds } = loaders(companyId)
            return loadByIds(TableName.CUSTOMERS, ids, dbRequest) as Promise<Customer[]>
        }

        const loadCustomersWithProp = async (
            propName: string,
            dbRequest = false
        ) => {
            const { loadFiltered } = loaders(companyId)
            return loadFiltered(TableName.CUSTOMERS, dbRequest, undefined, undefined, toList(propName)) as Promise<Customer[]>
        }

        const countCustomers = (
            startKey?: Params,
            limit?: number,
            propName?: string,
            propValue?: string,
        ) => {
            const { count } = loaders(companyId)
            const params = propName && propValue ? { [propName]: propValue } : undefined
            return count(TableName.CUSTOMERS, startKey, limit, params)
        }

        const countCustomers2 = (propName: string, propValue: string) => {
            const options = {
                valueFilters: [{
                    value: propValue,
                    prop: propName
                }],
                limit: 1
            }
            const { count2 } = loaders(companyId)
            return count2(TableName.CUSTOMERS, options)
        }

        return {
            loadAllCustomers,
            loadCustomersBatch,
            loadCustomer,
            loadCustomers,
            loadCustomersWithProp,
            countCustomers,
            countCustomers2
        }
    }
}
